module.exports = __webpack_public_path__ + "static/media/subtitle_summary.1f9c477b.svg";